import Config, {InvalidProviderError, NETWORKS} from "./Config";
import Token from "./Token";
import {Wallet} from "ethers";

export = {
  enums: {
    NETWORKS,
  },
  errors: {
    InvalidProviderError,
  },
  utils: {
    Wallet,
  },
  setProvider: Config.setProvider,
  setSigner: null,
  getProvider: Config.getProvider,
  Token: Token,
  Identity: null,
};
